<template>
  <div class="container">
    <div>
      <path-navigation
        v-if="lesson"
        :paths="[
          {
            name: `Warsztaty - ${lesson.theoryPracticeWorkshop.name}`,
            to: `/warsztaty-teoria-i-praktyka/${lesson.theoryPracticeWorkshop.id}`,
          },
          {
            name: `${lesson.name} - Praktyka`,
            to: `/warsztaty-teoria-i-praktyka/${lesson.theoryPracticeWorkshop.id}/lekcje/${this.$route.params.id}/praktyka`,
          },
        ]"
      />
      <div class="section-title" style="text-align: center;">
        Anatomia w praktyce
      </div>
      <section
        style="display: flex; justify-content:  center;flex-direction:column; align-items: center;"
      >
        <div class="title">
          <svg
            width="50"
            height="50"
            viewBox="0 0 120 120"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="60" cy="60" r="60" fill="#8B857D" />
            <path
              d="M59.4088 40.7688C62.519 40.7688 65.0402 38.2475 65.0402 35.1373C65.0402 32.0271 62.519 29.5059 59.4088 29.5059C56.2986 29.5059 53.7773 32.0271 53.7773 35.1373C53.7773 38.2475 56.2986 40.7688 59.4088 40.7688Z"
              fill="white"
            />
            <path
              d="M62.0937 20.3646C61.0407 21.52 70.6729 29.7669 70.6729 35.7027C70.6729 38.6722 66.3087 43.6607 65.1253 44.4869C64.4015 44.9932 62.0471 44.9031 59.2019 44.9404C57.4065 44.9684 53.881 44.9093 53.3157 44.344C51.8341 42.8624 48.0011 38.5107 48.0011 36.3208C48.0011 31.702 56.6766 20.8709 55.3285 20.0322C54.1047 19.265 42 32.4257 42 36.529C42 42.822 50.4518 52.0939 50.4518 52.0939C50.4518 52.0939 50.3835 64.8042 50.3835 66.1306C50.3835 77.5394 54.3625 100 57.8134 100C59.938 100 58.0805 88.06 58.0805 82.4037C58.0805 75.682 59.4069 68.9603 59.4069 68.9603C59.4069 68.9603 69.9895 72.6473 68.862 73.809C66.2155 76.533 59.0217 79.1764 59.9535 80.5741C61.1277 82.3322 71.6668 79.5833 77.9319 74.6352C80.5566 72.5634 67.3151 62.6299 67.3151 62.6299C67.3151 57.0917 67.3928 56.9612 67.1194 52.097C67.1194 52.097 76.1148 42.2846 76.1148 36.6967C76.1148 28.9437 63.6405 18.6624 62.0937 20.3646Z"
              fill="white"
            />
          </svg>

          <span class="sub-title">Praktyka</span>
        </div>

        <div class="content-section" v-if="practices && practices.length > 0">
          <theory-practice-lesson-practice
            v-for="practice in practices"
            :key="practice.id"
            :practice="practice"
            :customKey="practice.id"
          />
        </div>

        <div
          v-if="attachments && attachments.length > 0"
          class="content-section attachments-section"
        >
          <div class="attachments-header">
            <div class="attachments-icon-wrapper">
              <svg
                class="attachments-icon"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#fff"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                <polyline points="7 10 12 15 17 10"></polyline>
                <line x1="12" y1="15" x2="12" y2="3"></line>
              </svg>
            </div>
            <h3 class="attachments-title">Pliki do pobrania</h3>
          </div>
          <div class="attachments-container">
            <theory-practice-lesson-attachment
              :attachment="attachment"
              v-for="attachment in attachments"
              :key="attachment.id"
              class="attachment-item"
            />
          </div>
        </div>


        <div class="content-section">
          <comment-section
            v-if="lesson"
            :id="lesson ? lesson.id : null"
            :type="'lesson'"
            :lesson="lesson"
            :key="lesson ? lesson.id : new Date()"
            :isTheory="false"
          />
        </div>
      </section>
    </div>

    <div class="flex justify-center text-center" id="lessons-select"></div>
  </div>
</template>

<script>
import { SERVER_URL } from "../../axios";
import CommentSection from "../../components/CommentSection.vue";
import PathNavigation from "../../components/PathNavigation.vue";
import TheoryPracticeLessonAttachment from "./components/TheoryPracticeLessonAttachment.vue";
import TheoryPracticeLessonPractice from "./components/TheoryPracticeLessonPractice.vue";

export default {
  metaInfo: {
    title: "Dagajoga warsztaty - Anatomia w praktyce",
    meta: [
      { charset: "utf-8" },
      {
        name: "description",
        content:
          "Dagajoga to szkoła internetowa o wszechstronnym systemie budowania praktyki własnej.\nPraktyka jogi połączona z nowoczesnymi metodami ćwiczeń funkcjonalnych, ćwiczeń wzmacniających.",
      },
      {
        property: "og:image",
        content: "https://dagajoga.pl/wp-content/uploads/2022/02/image-5.png",
      },
    ],
  },
  name: "TheoryPracticeWorkshopLessonPractices",
  data: () => ({}),
  components: {
    PathNavigation,
    TheoryPracticeLessonPractice,
    CommentSection,
    TheoryPracticeLessonAttachment,
  },
  props: {
    path: String,
  },

  async mounted() {
    await this.$store.dispatch(
      "theoryPracticeWorkshopsLessons/fetchTheoryPracticeWorkshopsLesson",
      this.$route.params.id
    );

    await this.$store.dispatch(
      "theoryPracticeWorkshopsLessonsPractices/fetchTheoryPracticeWorkshopsLessonsPractices",
      {
        theoryPracticeWorkshopsLessonId: this.$route.params.id,
      }
    );

    await this.$store.dispatch(
      "theoryPracticeWorkshopsLessonsAttachments/fetchTheoryPracticeWorkshopsLessonsAttachments",
      {
        theoryPracticeWorkshopsLessonId: this.$route.params.id,
        type: "PRACTICE",
      }
    );

    const isPaid = await this.$store.dispatch(
      "theoryPracticeWorkshops/checkUserPaidForWorkshop",
      this.$route.params.workshopId
    );

    if (!isPaid) {
      this.redirectLogin();
    }
  },

  computed: {
    practices() {
      return this.$store.getters[
        "theoryPracticeWorkshopsLessonsPractices/getTheoryPracticeWorkshopsLessonsPractices"
      ];
    },
    lesson() {
      return this.$store.getters[
        "theoryPracticeWorkshopsLessons/getTheoryPracticeWorkshopLesson"
      ];
    },
    attachments() {
      return this.$store.getters[
        "theoryPracticeWorkshopsLessonsAttachments/getTheoryPracticeWorkshopsLessonsAttachments"
      ];
    },
  },
  methods: {
    getImageSrc(lesson) {
      const extension = lesson.imagePath.split(".")[1];

      const src = `${SERVER_URL}lessonsImages/${
        lesson.id
      }.${extension}?d=${new Date().getTime()}`;
      return src;
    },
    redirectLogin(signup) {
      this.$router.push({
        name: "Auth",
        params: { name: "", signup: signup },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 2560px;
  padding: 0 10px !important;
}
.type-content {
  border: 1px solid rgb(0, 0, 0, 0.25);
  padding: 1rem;
  border-radius: 20px;
  margin-bottom: 3rem;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}
.type-label {
  font-size: 30px;
  font-weight: 500;
}

.lessons {
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
}
.title {
  display: flex;
  align-items: center;
  gap: 1rem;
}
.title img {
  width: 50px;
}

.content-section {
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
}

/* Premium styling for the attachments section */
.attachments-section {
  margin: 2rem auto;
  padding: 1.5rem;
  border-radius: 15px;
  background: #d9d9d9;
  position: relative;
  overflow: hidden;
  box-sizing: border-box; /* Zapewnia, że padding nie zwiększy szerokości */
}

@media (max-width: 768px) {
  .attachments-section {
    padding: 1rem;
    margin: 1.5rem auto;
  }
}

.attachments-header {
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid rgba(139, 90, 43, 0.2);
  position: relative;
  flex-wrap: wrap; /* Pozwala na zawijanie na mniejszych ekranach */
}

.attachments-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 45px;
  height: 45px;
  margin-right: 1rem;
  background-color: #8b857d;
  border-radius: 50%;
  transition: all 0.3s ease;
  flex-shrink: 0; /* Zapobiega zmniejszaniu ikony */
}

@media (max-width: 480px) {
  .attachments-icon-wrapper {
    width: 40px;
    height: 40px;
    margin-right: 0.75rem;
  }
}

.attachments-icon-wrapper:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(139, 90, 43, 0.2);
  background-color: rgba(139, 90, 43, 0.15);
}

.attachments-icon {
  width: 20px;
  height: 20px;
  transition: all 0.3s ease;
  color: #fff !important;
}

.attachments-title {
  font-weight: 700;
  font-size: 22px;
  color: #8b857d;
  margin: 0;
  letter-spacing: 0.5px;
  position: relative;
}

@media (max-width: 480px) {
  .attachments-title {
    font-size: 18px;
  }
}

.attachments-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 1.5rem;
  padding: 0.5rem;
}

@media (max-width: 640px) {
  .attachments-container {
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 1rem;
    padding: 0.25rem;
  }
}

@media (max-width: 480px) {
  .attachments-container {
    grid-template-columns: 1fr; /* Jedna kolumna na bardzo małych ekranach */
  }
}

.attachment-item {
  transition: all 0.3s ease;
  width: 100%; /* Pełna szerokość w swoim gridzie */
}

.attachment-item:hover {
  transform: translateY(-3px);
}

@media (max-width: 480px) {
  .attachment-item:hover {
    transform: translateY(-2px); /* Mniejszy efekt na mobilnych urządzeniach */
  }
}
</style>
